//Vendor
import 'jquery';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import DataTable from 'datatables.net-bs4';

window.DataTable = DataTable;

//Site
import './Site.js';
import './SessionExpiry.js';
import './Chat.js';
import './chat-search.js';
